import { Permission } from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { useUserContext } from "contexts/UserContext";

import { hasPermissions } from "./utils";

const useHasPermissions = (permissions: Permission[]): boolean => {
  const { user } = useUserContext();
  const { userPermissions = [], venuePermissions = [] } = user?.me || {};

  return hasPermissions([...userPermissions, ...venuePermissions], permissions);
};

export default useHasPermissions;
